import { useCallback, useEffect, useMemo, useState } from 'react';
import { ErrorScreen, LogoIcon } from 'src/components';
import { Loading } from 'src/components/Loading';
import { useGetNearbyMappedAgencies } from 'src/hooks/useGetNearbyMappedAgencies';

export const HomeToStoreLandingPage = () => {
  const [position, setPosition] = useState<{ lat: number; lng: number } | null>(null);
  const [country, setCountry] = useState<string | null>(null);

  const [keyword, setKeyword] = useState<string>('');

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view_from_home_to_store_landing_page', {
        event_category: 'Navigation',
        event_label: 'Landing page',
      });
    }
  }, []);

  const handleAgencySelect = useCallback(
    (slug: string) => () => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'select_agency_to_send_from_home', {
          event_category: 'CTA',
          slug,
        });
      }
    },
    [],
  );

  const { data: agencies, isLoading, error, getNearbyMappedAgencies } = useGetNearbyMappedAgencies();

  // const localize = useCallback(() => {
  //   if (!navigator.geolocation) {
  //     return;
  //   }

  //   navigator.geolocation.getCurrentPosition(
  //     (location) => {
  //       setPosition({
  //         lat: location.coords.latitude,
  //         lng: location.coords.longitude,
  //       });
  //     },
  //     (err) => {
  //       console.error('Error getting location: ', err);
  //     },
  //   );

  //   if (typeof window.gtag === 'function') {
  //     window.gtag('event', 'localize_from_agency_home', {
  //       event_category: 'CTA',
  //       country,
  //     });
  //   }
  // }, [country]);

  // useEffect(() => {
  //   localize();
  // }, [localize]);

  useEffect(() => {
    if (position) {
      setKeyword('');
    }
  }, [position]);

  const filteredAgencies = useMemo(() => {
    if (position) {
      return agencies;
    }

    if (!keyword) {
      return agencies;
    }

    return agencies.filter((agency) => {
      const agencyCity = agency.agency?.city?.name?.toLowerCase();
      const zipCode = agency.agency?.zip?.toLowerCase();
      const searchTerm = keyword.toLowerCase();

      return agencyCity.includes(searchTerm) || zipCode.includes(searchTerm);
    });
  }, [agencies, keyword, position]);

  const trackContactUS = useCallback(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'contact_us_from_home_to_store_landing_page', {
        event_category: 'CTA',
        country,
      });
    }
  }, [country]);

  useEffect(() => {
    if (window.location.pathname.includes('/france')) {
      setCountry('fr');
    } else if (window.location.pathname.includes('/maroc')) {
      setCountry('ma');
    } else {
      setCountry(null);
    }
  }, []);

  const titleSend = useMemo(() => {
    // if (country === 'fr') {
    //   return `📦 Envoyez vos colis de France 🇫🇷 vers le Maroc 🇲🇦 !`;
    // } else if (country === 'ma') {
    //   return `📦 Envoyez vos colis du Maroc 🇲🇦 vers la France 🇫🇷 !`;
    // }
    return '📦 Envoi de colis entre la France🇫🇷 et le Maroc🇲🇦!';
  }, []);

  useEffect(() => {
    if (!country) {
      return;
    }

    getNearbyMappedAgencies({
      lat: position?.lat,
      lang: position?.lng,
      country,
    });
  }, [getNearbyMappedAgencies, position, country]);

  if (isLoading) {
    return <Loading />;
  }

  if (!country) {
    return <ErrorScreen error={new Error('country-not-supported')} />;
  }

  if (error || !agencies.length) {
    return <ErrorScreen error={error || new Error('no-agencies-found')} />;
  }

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 flex flex-col items-center">
      <div className="mb-6">
        <LogoIcon height={40} />
      </div>

      {/* Title */}
      <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center">{titleSend}</h2>

      {/* {!position && (
        <div className="my-2 justify-center items-center flex flex-col">
          <p className="text-gray-500">
            Nous avons besoin de votre localisation afin de vous trouver le partenaire le plus proche de vous.
          </p>
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition my-2 flex flex-row items-center justify-between"
            onClick={(e) => {
              e.preventDefault();
              localize();
              setKeyword('');
            }}
          >
            <MarkerIcon color="white" /> <span className="mx-2">Localisez-moi</span>
          </button>
        </div>
      )} */}

      {/* Location Prompt */}
      {/* {!position && (
        <div className="mb-6 text-center">
          <p className="text-gray-600">Où êtes-vous situé ?</p>
          <input
            type="text"
            onChange={(e) => setKeyword(e.target.value)}
            value={keyword}
            placeholder="Recherche"
            className="mt-2 px-4 py-2 border border-gray-300 rounded-md w-72 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      )} */}

      {/* Agency List */}
      <div className="w-full max-w-md space-y-4">
        <p className="text-gray-700 text-md">Choisissez la ville la plus proche de chez vous.</p>
        {filteredAgencies.map((agency, index) => (
          <div key={index} className="bg-white rounded-lg shadow-md p-4 flex flex-col  justify-between items-start">
            <div>
              <h3 className="text-lg font-bold text-blue-600">{agency.agency.city.name}</h3>
              <p className="text-gray-500">
                {agency.agency.zip}, {agency.agency.city.name}
              </p>
            </div>
            <div className="flex w-full justify-center mt-2">
              <a
                onClick={handleAgencySelect(agency.slug)}
                className="block mt-2 sm:mt-0 bg-blue-600 text-white px-4 py-4 rounded-lg hover:bg-blue-700 transition w-full text-center"
                href={`/home/${agency.slug}`}
              >
                Envoyer dans cette ville
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* Secondary Block */}
      <div className="mt-10 w-full max-w-md bg-gray-100 rounded-lg p-4 text-center">
        <p className="text-gray-700 font-medium">Êtes-vous un professionnel ?</p>
        <a
          onClick={trackContactUS}
          className="mt-3 block border border-blue-600 text-blue-600 px-4 py-2 rounded-lg hover:bg-blue-50 transition"
          href="mailto:contact@smartcolis.com?subject=Demande de partenariat"
        >
          📞 Contactez-nous !
        </a>
      </div>
    </div>
  );
};
